/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .media-types[_ngcontent-%COMP%]{margin-bottom:-6px!important;z-index:145545;position:relative}[_nghost-%COMP%]   .media-body[_ngcontent-%COMP%]{padding-bottom:10px;width:80em}@media screen and (max-width:1599px) and (min-width:1399px){[_nghost-%COMP%]   .media-body[_ngcontent-%COMP%]{width:90em}}@media screen and (max-width:1398px){[_nghost-%COMP%]   .media-body[_ngcontent-%COMP%]{width:85em}}"];
export { styles as styles };
